// API BASE URL
// export const BASE_URL = 'https://api.buku.kemendikdasmen.go.id';
export const BASE_URL = 'https://api.buku.cloudapp.web.id';
export const BASE_URL_PUSDATIN = 'https://api.buku.cloudapp.web.id';